/**
 * Les coordonnées du client qui réserve depuis le site d'un réparateur, sans
 * compte : prénom, nom, téléphone et email, les quatre obligatoires. Pur, sans
 * I/O ni React.
 *
 * Le contrôle des quatre est ICI : l'api n'exige encore que l'email OU le
 * téléphone (`PublicBookingController`), et l'atelier veut pouvoir écrire ET
 * appeler.
 */

export const CHAMPS = ['prenom', 'nom', 'tel', 'email'];

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Le nombre de chiffres d'un numéro, quel que soit son habillage (espaces, +33, points). */
const chiffres = (tel) => (tel || '').replace(/\D/g, '');

/**
 * Les erreurs par champ, en toutes lettres, ou un objet vide si tout est bon.
 * Un champ absent de l'objet est valide.
 */
export function erreursCoordonnees(valeurs) {
  const v = valeurs || {};
  const erreurs = {};
  if (!(v.prenom || '').trim()) erreurs.prenom = 'Indiquez votre prénom.';
  if (!(v.nom || '').trim()) erreurs.nom = 'Indiquez votre nom.';
  if (!(v.tel || '').trim()) {
    erreurs.tel = 'Indiquez votre numéro de téléphone.';
  } else if (chiffres(v.tel).length < 9) {
    erreurs.tel = 'Ce numéro semble incomplet.';
  }
  if (!(v.email || '').trim()) {
    erreurs.email = 'Indiquez votre adresse email.';
  } else if (!EMAIL.test(v.email.trim())) {
    erreurs.email = 'Cette adresse email semble incorrecte.';
  }
  return erreurs;
}

/** Les champs du formulaire d'après les clés d'une 422 de l'api. */
const CHAMP_DE_CLE = {
  'customer.first_name': 'prenom',
  'customer.last_name': 'nom',
  'customer.name': 'nom',
  'customer.phone': 'tel',
  'customer.email': 'email',
};

/**
 * Les erreurs d'une 422 de l'api, rangées sous le champ du formulaire qu'elles
 * nomment. `customer.name` (le tunnel d'avant) porte le prénom ET le nom : on le pose
 * sous le nom.
 * Ce qui ne correspond à aucun champ est ignoré ici (le tunnel l'affiche en
 * bandeau).
 */
export function erreursDepuisApi(fieldErrors) {
  const rangees = {};
  Object.keys(fieldErrors || {}).forEach((cle) => {
    const champ = CHAMP_DE_CLE[cle];
    const message = fieldErrors[cle] && fieldErrors[cle][0];
    if (champ && message) rangees[champ] = message;
  });
  return rangees;
}
